<template>
  <Error v-if="shouldCreateWorkspace" error="should-create-workspace" />
  <section v-else id="shopping">
    <router-link to="/bucket"
      ><button>Créer un nouveau panier</button></router-link
    >
    <BucketsList />
  </section>
</template>

<script>
import BucketsList from '../../components/Buckets/BucketsList/BucketsList.vue';

export default {
  components: {
    BucketsList,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped src="./Shopping.scss"></style>
